import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './styles/App.css';
import Contact from './components/contact';
import Home from './pages/Home';
import NavBar from './components/NavBar';
import About from './pages/About';
import Gallery from './pages/Gallery';
import GlobePage from './pages/3DGlobe';
import ArtMapDemo from './pages/ArtMapDemo';
import Francemap from './pages/francemap';
import Time from './pages/time';
const Portfolio = React.lazy(() => import('./pages/Portfolio'));

function App() {
  return (
    <Router>
      <div className="App">
        <NavBar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<React.Suspense fallback={<div>Loading...</div>}><Portfolio /></React.Suspense>} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/francemap" element={<Francemap />} />
            <Route path="/globe" element={<GlobePage />} />
            <Route path="/artmap" element={<ArtMapDemo />} />
            <Route path="/time" element={<Time />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
